import { Component, Prop, Watch } from '@stencil/core';
import { getProduct } from '@ugc-api/catalog';
import state from '@ugc-store';
import { IProductInfo } from '@ugc-utils/product';
import { createProductImageUrl } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-product',
  shadow: false,
})
export class UgcProduct {
  @Prop() productId: number;

  toProduct = data => {
    const { id, displayName, urlName, partNumber, brandName, brandUrl, primaryImageIndex, brandLogoUrl } = data;
    const productImageUrl = createProductImageUrl({
      partNumber,
      size: 100,
      index: primaryImageIndex,
      host: state.domains.static,
    });
    return {
      productId: id,
      displayName,
      productImageUrl,
      urlName,
      partNumber,
      brandName,
      brandUrl,
      brandLogoUrl,
    };
  };
  async getProduct(productId) {
    try {
      const data = (await getProduct(productId)) as IProductInfo;
      state.productInfo = this.toProduct(data);
    } catch (e) {}
  }
  async componentWillLoad() {
    this.getProduct(this.productId);
  }

  @Watch('productId')
  async watchProductIdHandler() {
    this.getProduct(this.productId);
  }

  render() {
    return null;
  }
}
